import React from "react"
import Typography from '@mui/material/Typography';


export const SourcesHyp = () => {

return(
<div>

<Typography component="span" variant="h5" sx={{fontWeight: '700'}}>Sources: </Typography>
<br /> <br />
Medline<br />
https://www.mdpi.com/1422-0067/22/8/4182  <br />    
https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6426691/  <br /> 
https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3612776/  <br /> 

</div>
)
}